import { post } from "./requests";

export function initChatWithCoach(coachId) {
  return post(`/owner/v1/chat/coach/${coachId}`).then(res => res.json());
}

export function initChatWithFamily(familyId) {
  return post(`/coach/v1/chat/family/${familyId}`).then(res => res.json());
}

export function initChatWithAllClients() {
  return post('/coach/v1/chat/all').then(res => res.json());
}
